import isSpotlightEnabled from './isSpotlightEnabled';
import processSpotlightItemsResponse from './processSpotlightItemsResponse';
import onSpotlightItemsFetched from '../actions/onSpotlightItemsFetched';
import fetchSpotlightItemsService from '../services/fetchSpotlightItemsService';
import { PerformanceDatapoint } from 'owa-analytics';
import { isConversationView } from 'owa-mail-list-store';
import { getDefaultInboxTableView } from 'owa-mail-triage-table-utils/lib/getDefaultInboxTableView';
import { isDogfoodEnv, getPhysicalRing } from 'owa-metatags';

export default function initializeSpotlight() {
    const POLL_INTERVAL = 60000;

    // Make initial request immediately.
    fetchSpotlightItems(true /* force */);

    /**
     * Polling for Spotlight updates is a temporary solution that we'll only use
     * in SDF and MSIT.
     */
    if (isDogfoodEnv() || getPhysicalRing() === 'MSIT') {
        // Poll for a new set of Spotlight items every POLL_INTERVAL milliseconds.
        setInterval(() => {
            fetchSpotlightItems(false /* force */);
        }, POLL_INTERVAL);
    }
}

/**
 * Fetches Spotlight items if page is visible.
 *
 * @param force Make request regardless if page is visible if true.
 */
const fetchSpotlightItems = async (force: boolean) => {
    // Don't make request if feature isn't enabled.
    if (!isSpotlightEnabled()) {
        return;
    }

    if (force || document.visibilityState === 'visible') {
        const inboxTableView = getDefaultInboxTableView();

        const networkPerformanceDatapoint = new PerformanceDatapoint('SpotlightService', {
            sessionSampleRate: 20,
        });
        const requestStartTime = Date.now();

        const spotlightResponse: Response = await fetchSpotlightItemsService(inboxTableView);

        networkPerformanceDatapoint.end();

        const spotlightItems = await processSpotlightItemsResponse(
            spotlightResponse,
            inboxTableView,
            networkPerformanceDatapoint
        );

        onSpotlightItemsFetched(
            spotlightItems,
            isConversationView(inboxTableView),
            requestStartTime
        );
    }
};
